import type { Creative, CreativeRevisionSnapshot } from '@/api/types';

/** Header metadata is current; copy, assets and status come from the exact pin. */
export function pinnedCreativeSnapshots(
  pins: Array<{ creative_id: string; creative_revision: number }>,
  headers: Array<Creative | undefined>,
  archives: Array<CreativeRevisionSnapshot[] | undefined>,
): Creative[] {
  return pins.flatMap((pin) => {
    const header = headers.find((creative) => creative?.id === pin.creative_id);
    const snapshot = archives.flatMap((rows) => rows ?? []).find((revision) =>
      revision.creative_id === pin.creative_id && revision.revision === pin.creative_revision);
    if (!header || !snapshot) return [];
    return [{
      ...header,
      ...snapshot,
      id: header.id,
      status: header.status === 'archived' ? 'archived' : snapshot.status,
    }];
  });
}

/** Replacing or removing an unreadable pin must clear its save refusal. */
export function unresolvedCreativeSlots(
  slots: Array<{ id: string; unresolved?: boolean }>,
  drafts: Array<{ key: string }>,
): number[] {
  return slots.flatMap((slot, index) =>
    slot.unresolved && !drafts.some((draft) => draft.key === slot.id) ? [index + 1] : []);
}
